module.exports = __webpack_public_path__ + "img/top图.2591f4d9.png";